import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'
import { HttpMethod } from '../../../services/core'

const resource = 'offers'
const verb = HttpMethod.POST

export default class OspreyOffersShareToSilos extends BaseAction {
    constructor(dataKey) {
        const id = 'ec59e0d3-4d98-46ff-b3ef-fba98c5b3537'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    shareToSilos(params) {
        const { offerId, siloIdList } = params

        this.path = `/${resource}/${offerId}/share/silos`

        this.params = {
            siloIdList
        }

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/offers/offers-silos-share.js